import Navbar from "./Navbar"
// import { BsSkipBackwardBtnFill } from "react-icons/bs"
import styles from "./ImgProfile.module.css"
function SectionApi () {
  return (
    <>
   <div className={styles.apibackground}>
   <Navbar/>
   </div>
     
     
    </>
  )
}

export default SectionApi
